import React from 'react';
import { useService } from '@xstate/react';
import HvSvg from 'src/components/HvSvg';
import { ScreenshotMachineContext } from 'src/machines/screenshotMachine';
import AspectRatio from 'src/components/AspectRatio';
import GallerySidebar from 'src/components/GallerySidebar';
import Lightbox from 'src/components/Lightbox';
import useGroundLevelRestrictedCamera from 'src/hooks/useGroundLevelRestrictedCamera';
import Notification from 'src/components/NotificationNew';
import {
  ScreenshotButton,
  ScreenshotModeContainer,
  AspectRatioAndGalleryContainer,
  CloseButtonContainer,
  ScreenshotModeTitle,
} from './styled';

interface ScreenshotModeProps {
  aspectRatio: number;
  macheteRoot: React.ReactElement;
  handleCloseScreenshotModeClick: () => null;
  screenshotMachineRef: any;
}

const ScreenshotMode: React.FunctionComponent<ScreenshotModeProps> = (
  props,
) => {
  const {
    macheteRoot,
    handleCloseScreenshotModeClick,
    screenshotMachineRef,
  } = props;
  const [state, send] = useService(screenshotMachineRef);
  const {
    lightboxRef,
    gallerySidebarRef,
    notifierMachineRef,
    captureIsInProgress,
  } = state.context as ScreenshotMachineContext;

  useGroundLevelRestrictedCamera();

  return (
    <ScreenshotModeContainer>
      <CloseButtonContainer
        data-selenium="exitGalleryButton"
        size={24}
        onClick={handleCloseScreenshotModeClick}
      >
        <HvSvg src={require('src/assets/icons/arrow.svg')} />
      </CloseButtonContainer>
      <AspectRatioAndGalleryContainer>
        <AspectRatio shouldFlash={state.matches('viewfinder.flash')}>
          <ScreenshotModeTitle>Camera</ScreenshotModeTitle>
          {macheteRoot}
          {state.matches('viewfinder') && (
            <ScreenshotButton
              data-selenium="takeScreenshotButton"
              onClick={() => send('TAKE_SCREENSHOT')}
            >
              Screenshot
            </ScreenshotButton>
          )}
        </AspectRatio>
        <GallerySidebar
          captureIsInProgress={captureIsInProgress!}
          gallerySidebarRef={gallerySidebarRef}
        />
      </AspectRatioAndGalleryContainer>
      {state.matches('lightbox') && (
        <Lightbox
          trackDownload={(isEnhanced: boolean) =>
            // @ts-ignore
            send({ type: 'LIGHTBOX_DOWNLOAD', isEnhanced })
          }
          exitLightbox={() => send('EXIT_LIGHTBOX')}
          lightboxRef={lightboxRef}
        />
      )}
      <Notification notifierMachineRef={notifierMachineRef} />
    </ScreenshotModeContainer>
  );
};

export default ScreenshotMode;
